import { useState, useEffect } from 'react';
import { getOngoingTrade } from '../../api-services/ongoingTrade';

export const OngoingTrade = () => {
    const [trade, setTrade] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchOngoingTrade();
        const interval = setInterval(fetchOngoingTrade, 30000); // Update every 30 seconds
        return () => clearInterval(interval);
    }, []);

    const fetchOngoingTrade = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await getOngoingTrade();
            if (response.ok) {
                const data = await response.json();
                if (data.success && data.data) {
                    setTrade(data.data);
                } else {
                    setTrade(null);
                }
            } else if (response.status === 404) {
                // No active trade
                setTrade(null);
            } else if (response.status === 401) {
                setError('Unauthorized');
            } else {
                setError('Failed to fetch ongoing trade');
            }
        } catch (error) {
            console.error('Error fetching ongoing trade:', error);
            setError('Error fetching ongoing trade');
        } finally {
            setLoading(false);
        }
    };

    const formatTime = (timeString) => {
        if (!timeString) return '--';
        const date = new Date(timeString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <div className="flex items-center justify-between mb-2">
                <h2 className="text-sm font-semibold text-white flex items-center gap-1.5">
                    <span>🔄</span> Ongoing Trade
                </h2>
                {loading && (
                    <div className="text-xs text-slate-400">Updating...</div>
                )}
            </div>

            {error && (
                <div className="p-2 bg-red-500/10 border border-red-500/20 rounded text-xs text-red-400">
                    {error}
                </div>
            )}

            {!trade && !error ? (
                <div className="bg-slate-900 p-3 rounded-lg text-center">
                    <div className="text-slate-400 text-xs mb-0.5">No Active Trade</div>
                    <div className="text-xs text-slate-500">Waiting for bot...</div>
                </div>
            ) : trade ? (
                <div className="bg-slate-900 p-3 rounded-lg">
                    <div className="flex items-center justify-between">
                        <div className="flex-1">
                            <div className="text-xs text-slate-400 mb-1">Current Direction</div>
                            <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-base font-bold ${
                                trade.direction === 'UP' 
                                    ? 'bg-green-500/20 text-green-400 border border-green-500/30' 
                                    : 'bg-red-500/20 text-red-400 border border-red-500/30'
                            }`}>
                                <span className="text-lg">{trade.direction === 'UP' ? '↑' : '↓'}</span>
                                <span>{trade.direction}</span>
                            </div>
                        </div>
                        
                        <div className="flex-1 text-right">
                            <div className="text-xs text-slate-400 mb-1">Time Placed</div>
                            <div className="text-xs font-medium text-white">
                                {trade.time_placement}
                            </div>
                            <div className="text-xs text-slate-500 mt-0.5">
                                {formatTime(trade.time_placement)}
                            </div>
                        </div>
                    </div>

                    <div className="mt-2 pt-2 border-t border-slate-800">
                        <div className="flex items-center justify-center gap-1.5">
                            <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
                            <span className="text-xs text-slate-400">Trade in progress</span>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
